export enum RegisterFormType {
    FormNarrow = 0,//Амбулатория
    Form12 = 1,//Стационар форма 12
    Form003 = 2,//Стационар форма 003
    Form096 = 3,
    Form097 = 4,
    Form0031 = 5,
    FormMedInspection = 6,//Мед Осмотр
    FormTriajGreen = 7,
    FormTriajYellow = 8,
    FormTriajRed = 9,
    ComissionGVVK = 10
}
